<template>
    <div>
        <div v-bind:id="setId" v-bind:style="{width: chartWidth,height: chartHeight}"></div>
    </div>
</template>
<script>
import echarts from "echarts";
export default {
  data() {
    return {
      charts: "",
      opinionData: []
    };
  },
  props: ["getData", "chartWidth", "chartHeight", "setId", "yNanme"],
  methods: {
    dealSeries: function() {
      let data = [];
      for (let i = 0; i < this.getData.list.length; i++) {
        data.push({
          name: this.getData.list[i].name,
          type: "line",
          symbolSize: 5,
          data: this.getData.list[i].data
        });
      }
      return data;
    },
    drawPie: function(id) {
      let that = this;
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        tooltip: {
          trigger: "item",
          formatter:function(parames){
            return '补货频次 : '+ parames.name + '<br />'+ '目标天数 : '+ parames.seriesName + '<br />'+ that.yNanme + ' : ' + parames.value;
          }
        },
        legend: {
          icon: "rect",
          type: 'scroll',
          itemWidth: 10,
          itemHeight: 10,
          bottom: -5,
          data: this.getData.days.toString().split(",")
        },
        grid: {
          top: 30,
          left: 50,
          right: 50,
          bottom: 30
        },
        color: [
          "#4e79a7",
          "#f28e2b",
          "#e15759",
          "#76b7b2",
          "#59a14f",
          "#edc948",
          "#b07aa1",
          "#ff9da7",
          "#9c755f"
        ],
        xAxis: [
          {
            name: "补货频次",
            nameTextStyle: {
              fontSize: 10,
              padding: [0, 0, 0, -10]
            },
            type: "category",
            boundaryGap: true,
            axisTick: {
              show: false
            },
            axisLabel: {
              padding: [-5, 0, 0, 0]
            },
            data:this.getData.frequency
            //data: ["1", "2", "3", "4", "5", "6"]
          }
        ],
        yAxis: [
          {
            name: '',
            nameTextStyle: {
              fontSize: 10,
              padding: [0, 0, -5, -10]
            },
            type: "value",
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel:{
              formatter: function (value, index) {
                if((value > 0 && value < 1000) || (value < 0 && value >-1000)){
                  return value;
                }else{
                  return (value/1000).toFixed(1) + 'k';
                }
              },
              fontSize:10
            },
            min:function(value){
              if(value.min > 20 ){
                return value.min - 20;
              }else{
                return value.min;
              }
              
            }
          }
        ],
        series: this.dealSeries()
      });
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.dealSeries();
      this.drawPie(this.setId);
    });
  },
  watch:{
        getData(val){    
          this.drawPie(this.setId);
        }
      }
};
</script>




// WEBPACK FOOTER //
// src/components/common/chart1.vue